import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Dropdown } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import ModalList from '../../components/Modals/ModalList';



export default function DGLTH_customer({ item, props, entity = null, refreshData }) {

    const navigate = useNavigate()

    const [customerHistoryEntity, setCustomerHistoryEntity] = useState(null)
    const [customerHistorySearchObj, setCustomerHistorySearchObj] = useState(null)
    const [statusCustomerModal, setStatusCustomerModal] = useState(false)
    const [statusPaymentModal, setStatusPaymentModal] = useState(false)
    const [paymentEntity, setPaymentyEntity] = useState(null)
    const [paymentSearchObj, setPaymentSearchObj] = useState(null)

    function showCustomerOffer(item) {
        let query = ''
        let fields = []
        let constraints = [{ "fieldName": "idCustomer", type: "value", value: item.id }]

        setCustomerHistorySearchObj({
            query: query,
            fields: fields,
            constraints: constraints
        })

        setCustomerHistoryEntity('customer_offer')
        setStatusCustomerModal(true)
    }

    function showCustomerOrder(item) {
        let query = ''
        let fields = []
        let constraints = [{ "fieldName": "idCustomer", type: "value", value: item.id }]

        setCustomerHistorySearchObj({
            query: query,
            fields: fields,
            constraints: constraints
        })

        setCustomerHistoryEntity('customer_order')
        setStatusCustomerModal(true)
    }

    function closeCustomerModal() {
        setCustomerHistoryEntity(null)
        setStatusCustomerModal(false)
    }

    function showModalPayment(item) {
        let query = ''
        let fields = []
        let constraints = [{ "fieldName": "idCustomer", type: "value", value: item.id }]

        setPaymentSearchObj({
            query: query,
            fields: fields,
            constraints: constraints
        })

        setPaymentyEntity('customer_order_payment')
        setStatusPaymentModal(true)
    }

    function closeModalPayment() {
        setPaymentyEntity(null)
        setStatusPaymentModal(false)
    }

    function newCustomerOffer(item) {
        navigate('/entity/customer_offer/add', {
            state: {
                body: {
                    idCustomer: item
                }
            }
        })
    }

    function newCustomerOrder(item) {
        navigate('/entity/customer_order/add', {
            state: {
                body: {
                    idCustomer: item
                }
            }
        })
    }


    if (entity !== null) {
        return (
            <>
                <Dropdown>
                    <Dropdown.Toggle variant="outline-secondary" size='sm'>
                        Azioni
                    </Dropdown.Toggle>
                    <Dropdown.Menu>
                        <Dropdown.Header className='small text-muted'>Preventivi</Dropdown.Header>
                        <Dropdown.Item onClick={() => showCustomerOffer(item)} className='small'><FontAwesomeIcon icon="list" className='me-2' fixedWidth />Visualizza</Dropdown.Item>
                        <Dropdown.Item onClick={() => newCustomerOffer(item)} className='small'><FontAwesomeIcon icon="plus" className='me-2' fixedWidth />Crea preventivo</Dropdown.Item>
                        <Dropdown.Divider />
                        <Dropdown.Header className='small text-muted'>Ordini</Dropdown.Header>
                        <Dropdown.Item onClick={() => showCustomerOrder(item)} className='small'><FontAwesomeIcon icon="list" className='me-2' fixedWidth />Visualizza</Dropdown.Item>
                        <Dropdown.Item onClick={() => newCustomerOrder(item)} className='small'><FontAwesomeIcon icon="plus" className='me-2' fixedWidth />Crea ordine</Dropdown.Item>
                        <Dropdown.Divider />
                        <Dropdown.Item onClick={() => showModalPayment(item)} className='small'><FontAwesomeIcon icon="clock-rotate-left" className='me-2' fixedWidth />Storico pagamenti</Dropdown.Item>
                    </Dropdown.Menu>
                </Dropdown>

                {statusCustomerModal && customerHistoryEntity ? <ModalList entity={customerHistoryEntity} searchObj={customerHistorySearchObj} status={statusCustomerModal} closeModal={closeCustomerModal} /> : <></>}
                {statusPaymentModal && paymentEntity ? <ModalList entity={paymentEntity} searchObj={paymentSearchObj} status={statusPaymentModal} closeModal={closeModalPayment} /> : <></>}
            </>
        )
    }
    else {
        return (
            <></>
        )
    }
};
